/* Michele Care — comportements de la zone estivale de la page d'accueil.
   Chargé par les sections « mc-* ». S'initialise une seule fois. */
(function () {
  if (window.__mcSummerInit) return;
  window.__mcSummerInit = true;

  /* Apparition au défilement.
     La classe qui masque l'élément n'est posée qu'ici : sans JS, tout reste visible. */
  function initReveal() {
    var targets = document.querySelectorAll('[data-mc-reveal]:not(.mc-reveal)');
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );

    targets.forEach(function (el, index) {
      el.classList.add('mc-reveal');
      el.style.transitionDelay = Math.min(index % 6, 5) * 60 + 'ms';
      observer.observe(el);
    });

    /* Filet de sécurité : un élément situé au-dessus de la position d'arrivée
       ne traverse jamais l'écran et resterait invisible. Au bout de quelques
       secondes, on révèle tout ce qui ne l'a pas été. */
    if (!window.__mcRevealFilet) {
      window.__mcRevealFilet = true;
      setTimeout(function () {
        document.querySelectorAll('.mc-reveal:not(.is-in)').forEach(function (el) {
          el.style.transitionDelay = '0ms';
          el.classList.add('is-in');
        });
      }, 4000);
    }
  }

  /* Vidéo : le fichier n'est téléchargé qu'au premier clic. */
  function initVideos() {
    document.querySelectorAll('.mc-video__tile:not([data-mc-bound])').forEach(function (tile) {
      tile.setAttribute('data-mc-bound', '');

      var video = tile.querySelector('video');
      var button = tile.querySelector('.mc-video__play');
      if (!video || !button) return;

      button.addEventListener('click', function () {
        document.querySelectorAll('.mc-video__tile.is-playing').forEach(function (other) {
          if (other === tile) return;
          var otherVideo = other.querySelector('video');
          if (otherVideo) otherVideo.pause();
          other.classList.remove('is-playing');
        });

        var deferred = video.getAttribute('data-mc-src');
        if (deferred && !video.getAttribute('src')) {
          video.setAttribute('src', deferred);
          video.setAttribute('preload', 'auto');
        }

        video.setAttribute('controls', 'controls');
        tile.classList.add('is-playing');
        var played = video.play();
        if (played && typeof played.catch === 'function') played.catch(function () {});
      });

      video.addEventListener('pause', function () {
        tile.classList.remove('is-playing');
      });

      video.addEventListener('ended', function () {
        tile.classList.remove('is-playing');
        video.currentTime = 0;
      });
    });
  }

  function init() {
    initReveal();
    initVideos();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* L'éditeur de thème recharge les sections dynamiquement. */
  document.addEventListener('shopify:section:load', init);
})();
